import React from 'react';
import Image from 'next/image';
import { useTranslations } from 'next-intl';
import { trackGAEvent } from '@/features/Analytics/utils/trackEvent';
import { Link } from '@/navigation';
import inputsIcon from '@/shared/assets/sprites/inputs.sprite.svg';
import type { ProfiledDoctorCardProps } from '../model/types';
export const ProfiledDoctorCard: React.FC<ProfiledDoctorCardProps> = ({
  fullName,
  workExperience,
  rating,
  avatar,
  skill,
  href
}) => {
  const t = useTranslations('doctor.recommendation');
  const handleClick = () => {
    trackGAEvent('click_doctor_recommendation_widget', {
      doctorName: fullName,
      skill
    });
  };
  return <article className="grid grid-cols-[100px_auto_40px] items-center gap-3 border-b pb-2 last:border-none" data-sentry-component="ProfiledDoctorCard" data-sentry-source-file="ProfileDoctorCard.tsx">
      <div className="flex flex-col items-center">
        <Link href={href} prefetch={false} onClick={handleClick} className="flex flex-col items-center" data-sentry-element="Link" data-sentry-source-file="ProfileDoctorCard.tsx">
          <Image src={avatar} alt={fullName} width={68} height={68} className="rounded-full" data-sentry-element="Image" data-sentry-source-file="ProfileDoctorCard.tsx" />
          <p className="mt-1 items-center text-xs">
            {t('rating')} <span className="font-bold">★</span> <span className="font-bold">{rating}</span>
          </p>
        </Link>
      </div>

      <div className="flex flex-col justify-center">
        <Link href={href} prefetch={false} onClick={handleClick} className="transition-colors hover:text-primary" data-sentry-element="Link" data-sentry-source-file="ProfileDoctorCard.tsx">
          <h3 className="mb-2 text-base font-medium leading-5">{fullName}</h3>
          <p className="mb-1 text-xs font-medium text-additionalBlue">
            {workExperience ? t('experience', {
            count: workExperience
          }) : ''}
          </p>
          <p className="text-xs text-gray-600">{skill}</p>
        </Link>
      </div>

      <Link href={href} prefetch={false} onClick={handleClick} className="flex items-center justify-center" data-sentry-element="Link" data-sentry-source-file="ProfileDoctorCard.tsx">
        <svg className="size-6 rotate-90 font-normal" data-sentry-element="svg" data-sentry-source-file="ProfileDoctorCard.tsx">
          <use xlinkHref={`${inputsIcon}#chevron-up`} data-sentry-element="use" data-sentry-source-file="ProfileDoctorCard.tsx" />
        </svg>
      </Link>
    </article>;
};